import { useMemo } from "react";

import { deserialize } from "@smart/itops-serialisation-basic";

export const useParsed = (value?: string) =>
  useMemo(() => (value ? deserialize(value) : null), [value]);
